import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    lng: 'en-US',
    fallbackLng: 'en-US',
    interpolation: {
      escapeValue: false,
    },
    // debug: true,
    resources: {
      'en-US': {
        translation: {
          'download': 'Download',
          'cancel': 'Cancel',
          'modal-title': 'Customize Your Document',
          'preview': 'Preview',
          'logo-drop': 'Drag your logo here, or click to select',
          'waiting-message': 'Please wait while your document is generated',
          'performance-button': 'Performance',
          'fund-details': 'Fund Details',
          'category': 'Category',
          'ratings': 'Ratings',
          'fundstdperformance-footnote': '<strong>Performance is historical and does not guarantee future results. Current performance may be lower or higher than quoted. Investment returns and principal value of an investment will fluctuate so that an investor\'s shares, when redeemed, may be worth more or less than their original cost. Standardized and the most recent month-end performance data for the funds can be found on the individual funds\' website. For this and other important information please click on the fund\'s ticker symbol above.</strong> <br/><br/>You cannot invest directly in an index. Index performance does not represent actual fund or portfolio performance. A fund or portfolio may differ significantly from the securities included in the index. Index performance assumes reinvestment of dividends but does not reflect any management fees, transaction costs or other expenses that would be incurred by a portfolio or fund, or brokerage commissions on transactions in fund shares. Such fees, expenses and commissions could reduce returns. WisdomTree, its affiliates and their independent providers are not liable for any informational errors, incompleteness or delays or for any actions taken in reliance on information contained herein.<br/><br/>See <a href="https://www.wisdomtree.com/index" target="_blank">All Indexes</a> for links to WisdomTree index details. Definitions of other indexes can be found in the <a href="https://www.wisdomtree.com/glossary" target="_blank">Glossary</a>.<br/><br/>Common Period - the time period over which all funds and indexes existed and have pricing history.'
        },
      },
      'en-GB': {
        translation: {
          'Personal Strategies': 'Personal Strategies',
          'intro-text': 'Analyse and track your favorite portfolios.',
        }
      },
    },
  });

export default i18n;